import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../registration.service';

import { FormGroup, FormControl, NgForm } from '@angular/forms';
import { forEach } from '@angular/router/src/utils/collection';
import swal from 'sweetalert2';
import { HandleError } from '../../shared/HandleError';

@Component({
  selector: 'app-awards',
  templateUrl: './awards.component.html',
  styleUrls: ['./awards.component.css']
})

export class AwardsComponent implements OnInit {
  formInvalid: boolean = false;
  SainikDetails: any;
  AwardsMasters: any = {};
  AwardsMastersTwo: any = {};
  data: any;
  s: any = {};
  isSainikExist: boolean = false;
  title = "Awards";
  mode: string = "save";
  ng: any;
  nonGal: any;
  g: any;
  RoleName: string;
  UserName: any;
  finalizeddata: any;
  Formdiable: boolean = false;
  awardTypes:any;


  constructor(private service: RegistrationService,private handleError:HandleError) {
  }

  ngOnInit() {
    this.GetAllAwardsMasters();
    this.GetAllAwardTypes();
    this.GetfinalizedDataForAwards(this.s.SR_ServiceNo);
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');    
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    this.s.SR_ServiceNo=this.UserName;    
    // this.GetSainikBasicDetails(this.s.SR_ServiceNo)    
    this.GetSainikDetailsFromRegistration(this.s.SR_ServiceNo);    
    }
  }
  GetAllAwardTypes()
  {
    debugger;
    this.data = this.service.getAllAwardTypes();
    this.data.subscribe(
      (response) => {
        this.awardTypes=response;        
      },
      (error) => {
        console.log(error);
      });
  }  
  GetfinalizedDataForAwards(SR_ServiceNo)
  {
    debugger;    
    this.data = this.service.getfinalizedDataForAwards(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
      this.finalizeddata=response;        
      if(this.finalizeddata=='F')
      {
        this.Formdiable=true;
      }
      if (this.finalizeddata=="" || this.finalizeddata == null)
      {        
        this.s.Award_Type='undefined';
      }
      },
      (error) => {
        console.log(error);
      });
  }

  GetSainikDetailsFromRegistration(SR_ServiceNo: any) {
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getSainikBasicDetailsForAwards(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.s = response.sainikRegistrationBasicDetails;
        this.isSainikExist = true;
        this.s.SR_Id = response.sainikRegistrationBasicDetails.SR_Id;
        this.AwardsMasters = response.Awards;
        //this.AwardsMastersTwo=response.Awards;
        this.s.Award_Type = 'B';
        if (!this.CheckGallentryAwards() && !this.CheckNonGallentryAwards())
          this.mode = "save";
        else {
          debugger;
          this.mode = "update";
          if (this.CheckGallentryAwards() && this.CheckNonGallentryAwards())
          {
            this.s.Award_Type = 'B';
          }
          else if (this.CheckGallentryAwards())
            this.s.Award_Type = 'G';
          else
            this.s.Award_Type = 'NG';
        }
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400)
          //swal('Warning!', 'Sainik does not exist.', 'warning');
          swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }

 

  GetAllAwardsMasters() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllAwardsMasters();
    this.data.subscribe(
      (response) => {
        this.AwardsMasters = response;
        this.s.Award_Type='B';
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

   awardchange()
   {
   debugger;
   if(this.s.Award_Type=="G"){
    //this.AwardsMasters.GallentryAwards=this.AwardsMastersTwo.GallentryAwards;
     //document.getElementById("nonGal").style.display = "none";
     let invalidCount = 0;
    for (let i = 0; i < this.AwardsMasters.NonGallentryAwards.length; i++) {
      //this.ng.IsSelected=false;
      this.AwardsMasters.NonGallentryAwards[i].IsSelected=false;
    }
    
   }else if(this.s.Award_Type=="NG"){
    //this.AwardsMasters.NonGallentryAwards=this.AwardsMastersTwo.NonGallentryAwards;
     //document.getElementById("nonGal").style.display = "block";
     for (let i = 0; i < this.AwardsMasters.GallentryAwards.length; i++) {
      //this.ng.IsSelected=false;
      this.AwardsMasters.GallentryAwards[i].IsSelected=false;
    }
  }
    //else{
      //this.GetAllAwardsMasters();
    // this.AwardsMasters.GallentryAwards={}; 
    // this.AwardsMasters.GallentryAwards="";
     //this.AwardsMasters.GallentryAwards=undefined; 
     //this.g.Award_Id="";  
      //this.g.checked=false;
     //this.AwardsMasters.GallentryAwards.IsSelected = false;
  // }
  }


  GetSainikBasicDetails(SR_ServiceNo: any) {
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getSainikBasicDetailsForAwards(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.s = response.sainikRegistrationBasicDetails;
        this.isSainikExist = true;
        this.s.SR_Id = response.sainikRegistrationBasicDetails.SR_Id;
        this.AwardsMasters = response.Awards;
        //this.AwardsMastersTwo=response.Awards;
        this.s.Award_Type = 'B';
        if (!this.CheckGallentryAwards() && !this.CheckNonGallentryAwards())
          this.mode = "save";
        else {
          debugger;
          this.mode = "update";
          if (this.CheckGallentryAwards() && this.CheckNonGallentryAwards())
          {
            this.s.Award_Type = 'B';
          }
            
          else if (this.CheckGallentryAwards())
            this.s.Award_Type = 'G';
          else
            this.s.Award_Type = 'NG';
        }
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400)
        if(this.RoleName=="Super Admin"){
          swal('Warning!', 'Sainik does not exist.Please fill the details', 'warning');
        }
        else{
        swal('Warning!', 'Sainik does not belong to this district or Sainik does not exist', 'warning');
         }
          //swal('Warning!', 'Sainik does not exist.', 'warning');
         // swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }

  ClearForm(){
    this.s.SR_ServiceType="";
     this.s.SR_Category="";
     this.s.SR_Name="";
     this.s.SR_SurName="";
}
keyPress(event: any) 
{
  debugger;
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    // console.log(inputChar, e.charCode);
    let inputChars = new Number((event.target.value + inputChar).substring(0,2));
    if (inputChars==0)
    {
      event.preventDefault();
    }
    if (!pattern.test(inputChar)) 
    {
       // invalid character, prevent input
       event.preventDefault();
    }
}

  SaveSainikAwards(sainikId, aw: NgForm, AwardsMasters) {
   //if (this.CheckValidation()) {
      debugger;
      //this.CheckValidGallentryAwards();
      //this.CheckNonGallentryAwards();

      //this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.saveSainikAwards(sainikId, this.AwardsMasters);
      this.data.subscribe(
        (response) => {
          console.log(aw);
          if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
            this.GetSainikDetailsFromRegistration(this.UserName);
          }
          else{
          aw.reset();
          aw.resetForm();
          this.s.SR_ServiceType="";
          this.s.SR_Category="";
          this.s.SR_Name="";
          this.s.SR_SurName="";
          this.s.Award_Type="undefined";
          }
          this.formInvalid = false;
          swal('Success!', 'Sainik Awards has been saved successfully.', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          document.getElementById('ServiceNo').focus();
          this.GetAllAwardsMasters();
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
        });
    //}
    // else {
    //   swal('Warning!', 'There are errors, please select atleast one award.', 'warning');
    //   this.formInvalid = true;
    // }
  }

  UpdateSainikAwards(sainikId, aw: NgForm, AwardsMasters) {
   // if (this.CheckValidation()) {
      debugger;
      //this.formInvalid = false;
      //this.CheckValidNonGallentryAwards() ;
      //this.CheckValidGallentryAwards();
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.updateSainikAwards(sainikId, this.AwardsMasters);
      this.data.subscribe(
        (response) => {
          console.log(aw);
          if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
            this.GetSainikDetailsFromRegistration(this.UserName);
          }
          else{
          aw.reset();
          aw.resetForm();
          this.s.SR_ServiceType="";
          this.s.SR_Category="";
          this.s.SR_Name="";
          this.s.SR_SurName="";
          this.s.Award_Type="undefined";
          }
          this.formInvalid = false;
          swal('Success!', 'Sainik Awards has been updated successfully.', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          document.getElementById('ServiceNo').focus();
          this.GetAllAwardsMasters();
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
        });
    //}
    // else {
    //   swal('Warning!', 'There are errors, please select atleast one award.', 'warning');
    //   this.formInvalid = true;
    // }
  }

  CheckValidation() {
    let result1: boolean = this.isSainikExist;
    let result2: boolean = this.CheckGallentryAwards();
    let result3: boolean = this.CheckNonGallentryAwards();
    let result4: boolean = this.CheckValidNonGallentryAwards();
    let result5: boolean = this.CheckValidGallentryAwards();

    if (result1 && (result2 || result3) && result4 && result5)
      return true;
    else
      return false;
  }

  CheckRequired(value) {
    if (typeof (value) != undefined && value != '' && value != null)
      return true;
    else
      return false;
  }

  CheckGallentryAwards() {
    let checkedCount = 0;
    for (let i = 0; i < this.AwardsMasters.GallentryAwards.length; i++) {
      if (this.AwardsMasters.GallentryAwards[i].IsSelected)
        checkedCount++;
    }
    if (checkedCount > 0)
    {
      
      return true;
    }
    else
    {
      this.s.Award_Type='undefined';
      return false;
    }
    
  }

  CheckNonGallentryAwards() {
    let checkedCount = 0;
    for (let i = 0; i < this.AwardsMasters.NonGallentryAwards.length; i++) {
      if (this.AwardsMasters.NonGallentryAwards[i].IsSelected) 
        checkedCount++;
      }
      if (checkedCount > 0)        
      {        
        return true;
      }
      else
      {
        this.s.Award_Type='undefined';
        return false;
      }
  }

  CheckValidGallentryAwards() {
    debugger;
    let invalidCount = 0;
    for (let i = 0; i < this.AwardsMasters.GallentryAwards.length; i++) {
      if (this.AwardsMasters.GallentryAwards[i].IsSelected) {
        if (this.AwardsMasters.GallentryAwards[i].AwardCount > 0)
          this.AwardsMasters.GallentryAwards[i].GAwardCountErrMsg = "";
        else {
          this.AwardsMasters.GallentryAwards[i].GAwardCountErrMsg = "Enter count greater than 0 and less than 100";
          invalidCount++;
        }
      }
    }
    if (invalidCount > 0)
      return false;
    else
      return true;
  }

  CheckValidNonGallentryAwards() {
    let invalidCount = 0;
    for (let i = 0; i < this.AwardsMasters.NonGallentryAwards.length; i++) {
      if (this.AwardsMasters.NonGallentryAwards[i].IsSelected) {
        if (this.AwardsMasters.NonGallentryAwards[i].AwardCount > 0)
          this.AwardsMasters.NonGallentryAwards[i].NGAwardCountErrMsg = "";
        else {
          this.AwardsMasters.NonGallentryAwards[i].NGAwardCountErrMsg = "Enter count greater than 0 and less than 100";
          invalidCount++;
        }
      }
    }
    if (invalidCount > 0)
      return false;
    else
      return true;
  }

  ChangeCheckBoxForGA(pos) {
    if (this.AwardsMasters.GallentryAwards[pos].IsSelected)
      this.AwardsMasters.GallentryAwards[pos].IsSelected = false;
    else {
      this.AwardsMasters.GallentryAwards[pos].IsSelected = true;
      this.AwardsMasters.GallentryAwards[pos].AwardCount = 1;
      let x: any = document.getElementById('gaCount_' + pos);
      if (x != null)
        x.value = 1;
    }
  }

  ChangeCountForGA(pos) {
    let x: any = document.getElementById('gaCount_' + pos);
    this.AwardsMasters.GallentryAwards[pos].AwardCount = x.value;
  }

  ChangeCheckBoxForNGA(pos) {
    if (this.AwardsMasters.NonGallentryAwards[pos].IsSelected)
      this.AwardsMasters.NonGallentryAwards[pos].IsSelected = false;
    else {
      this.AwardsMasters.NonGallentryAwards[pos].IsSelected = true;
      this.AwardsMasters.NonGallentryAwards[pos].AwardCount = 1;
      let x: any = document.getElementById('ngaCount_' + pos);
      if (x != null)
        x.value = 1;
    }
  }

  ChangeCountForNGA(pos) {
    let x: any = document.getElementById('ngaCount_' + pos);
    this.AwardsMasters.NonGallentryAwards[pos].AwardCount = x.value;
    console.log(x.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/awards/awards.component.ts